import { DEMO_APP_ID } from "../common/constants";

export const demoAppData = {
  allow_reuse_shortlink: false,
  app_description: "Airflex Demo",
  app_id: DEMO_APP_ID,
  app_name: "Airflex Demo",
  app_secret: "****************************************",
  connected_apps: [
    {
      id: 134,
      type: "jssdk",
      app_url: null,
      app_icon: null,
      app_title: null,
      bundle_id: null,
      // ... thêm các trường khác nếu cần
    },
    // ... thêm các app khác nếu cần
  ],
  created_at: "2025-06-24T03:08:53.391Z",
  currencies: null,
  deleted_at: null,
  dynamic_link_custom_domain: null,
  dynamic_link_prefix: null,
  facebook_token: null,
  icon_in_deeplink: null,
  id: 0,
  name_in_deeplink: null,
  partner_app_host_prefix: null,
  partner_code: "airflex_demo",
  session_expire_time_in_seconds: 60,
  short_link_custom_domain: null,
  shorten_custom_domain: null,
  updated_at: "2025-06-24T03:08:53.391Z",
  white_list_hosts: [],
};
